import View from "./View.js";
import icons from "url:../../img/icons.svg";

class PaginationView extends View {
  _parentElement = document.querySelector(`.pagination`);

  addhandlerClick(handler) {
    this._parentElement.addEventListener(`click`, function(e) {
      const btn = e.target.closest(`.btn--inline`);
      if(!btn) return;
      const goToPage = +btn.dataset.goto;
      console.log(goToPage);

      handler(goToPage);
    })
  }

  _generateMarkup() {
    const currPage = this._data.page;
    const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
    console.log(numPages);
    // page 1 and other pages
    if(currPage === 1 && numPages>1) {
      return this._generateMarkupNextBtn(currPage);
    } 
    // page last
    else if(currPage === numPages && numPages>1) {
      return this._generateMarkupPrevBtn(currPage);
    }
    // page >1
    else if(currPage > 1 && numPages>1) {
      return this._generateMarkupPrevBtn(currPage).concat(this._generateMarkupNextBtn(currPage));
    } 
    // page 1 and no other pages
    else if(currPage === 1 && numPages === 1) {
      return ``;
    } 
  }

  _generateMarkupPrevBtn(currPage) {
    return `
      <button data-goto = ${currPage -1} class="btn--inline pagination__btn--prev">
      <svg class="search__icon">
      <use href="${icons}#icon-arrow-left"></use>
      </svg>
      <span>Page ${currPage -1}</span>
      </button>
      `;
  }

  _generateMarkupNextBtn(currPage) {
    return `
      <button data-goto = ${currPage + 1} class="btn--inline pagination__btn--next">
      <span>Page ${currPage + 1}</span>
      <svg class="search__icon">
      <use href="${icons}#icon-arrow-right"></use>
      </svg>
      </button>
      `;
  }
    
}

export default new PaginationView